import MNPG from "./MNPG";
// type
import { TMainPageLayoutV3 } from "../type";


const MNPG012 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG012.rendered: ", props);

    if ( !props.template ) return null;

    return (
        <div className="col-lg-8">
            <MNPG templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} params={props.params} />
        </div>
    )
}

export default MNPG012;
